'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _DialogConstants = require('./DialogConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIDialog',

  propTypes: {
    centered: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    _dialogWidth: _react.PropTypes.number,
    role: _react.PropTypes.string,
    size: _react.PropTypes.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
    style: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(_DialogConstants.USE_CLASSES))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      centered: false,
      use: 'default',
      size: 'medium'
    };
  },
  render: function render() {
    var _props = this.props,
        centered = _props.centered,
        children = _props.children,
        className = _props.className,
        _dialogWidth = _props._dialogWidth,
        style = _props.style,
        use = _props.use,
        size = _props.size,
        rest = _objectWithoutProperties(_props, ['centered', 'children', 'className', '_dialogWidth', 'style', 'use', 'size']);

    return _react2.default.createElement(
      'div',
      _extends({}, rest, {
        className: (0, _reactUtils.classNames)('private-modal', _DialogConstants.USE_CLASSES[use], _DialogConstants.SIZE_CLASSES[size], 'uiDialog-root', className, {
          'private-modal--centered': centered
        }),
        style: _extends({ width: _dialogWidth }, style)
      }),
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/dialog/UIDialog.js
// module id = 323
// module chunks = 0